var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75C10.2051 3.75 8.75 5.20507 8.75 7C8.75 8.79493 10.2051 10.25 12 10.25C13.7949 10.25 15.25 8.79493 15.25 7C15.25 5.20507 13.7949 3.75 12 3.75ZM7.25 7C7.25 4.37665 9.37665 2.25 12 2.25C14.6234 2.25 16.75 4.37665 16.75 7C16.75 9.62335 14.6234 11.75 12 11.75C9.37665 11.75 7.25 9.62335 7.25 7Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75034 20.2497C3.7527 20.2499 3.75518 20.25 3.7578 20.25H20.2422C20.2448 20.25 20.2473 20.2499 20.2497 20.2496C20.2305 18.84 19.4067 17.4906 17.9339 16.4597C16.4459 15.4181 14.3503 14.75 12 14.75C9.64973 14.75 7.55413 15.4181 6.06614 16.4597C4.5933 17.4906 3.76951 18.84 3.75034 20.2497ZM5.20594 15.2308C6.97531 13.9922 9.37971 13.25 12 13.25C14.6203 13.25 17.0247 13.9922 18.7941 15.2308C20.5611 16.4677 21.75 18.2484 21.75 20.3C21.75 21.1944 20.9815 21.75 20.2422 21.75H3.7578C3.01846 21.75 2.25 21.1944 2.25 20.3C2.25 18.2484 3.43895 16.4677 5.20594 15.2308Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/Person.7c254cb1a3b285b2c797af87ca464d46.svg";
export { ForwardRef as ReactComponent };